export default __webpack_public_path__ + "static/media/GoldBenefits4.0445b571.svg";